import { FC, MutableRefObject } from 'react'
import { useTranslation } from 'react-i18next'
import {
  GridColumnMenuColumnsItem,
  GridColumnMenuContainer,
  GridColumnMenuPinningItem,
  GridColumnMenuProps,
} from '@microservices/wiskey-react-table-component'
import { GridApiPro } from '@microservices/wiskey-react-table-component/dist/DataGrid/DataGridV7/models/gridApiPro'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import ReplayIcon from '@mui/icons-material/Replay'
import { CircularProgress, ListItemIcon, MenuItem } from '@mui/material'

type CustomColumnMenuComponentProps = {
  onShowConfig?: (value: boolean) => void
  visibleItems?: string[]
  apiRef?: MutableRefObject<GridApiPro> | null
  handleAutosizeColumns?: () => void | Promise<void>
  handleResetRestrictions?: () => void | Promise<void>
  isAutosizingColumns?: boolean
  isResettingRestrictions?: boolean
  hideShowOptions?: boolean
} & GridColumnMenuProps

const MENU_ICON_SLOT_SX = { minWidth: 36, justifyContent: 'center' }

export const CustomColumnMenuComponent: FC<CustomColumnMenuComponentProps> = props => {
  const { colDef, hideMenu, visibleItems = ['show', 'pinned', 'autosize', 'reset'] } = props
  const currentColumn = colDef
  const { t } = useTranslation()

  const {
    apiRef,
    handleAutosizeColumns,
    handleResetRestrictions,
    hideShowOptions = false,
    isAutosizingColumns = false,
    isResettingRestrictions = false,
    onShowConfig,
    ...gridColumnMenuContainerProps
  } = props

  const isColumnMenuBusy = isAutosizingColumns || isResettingRestrictions

  return (
    <GridColumnMenuContainer {...gridColumnMenuContainerProps}>
      {/*<GridColumnMenuHideItem*/}
      {/*  colDef={currentColumn}*/}
      {/*  onClick={e => {*/}
      {/*    hideMenu(e)*/}
      {/*  }}*/}
      {/*/>*/}
      {!hideShowOptions && visibleItems?.includes('show') && (
        <GridColumnMenuColumnsItem
          colDef={currentColumn}
          disabled={isColumnMenuBusy}
          onClick={e => {
            hideMenu(e)
            onShowConfig?.(true)
          }}
        />
      )}
      {visibleItems?.includes('pinned') && (
        <GridColumnMenuPinningItem
          colDef={currentColumn}
          disabled={isColumnMenuBusy}
          onClick={e => {
            hideMenu(e)
          }}
        />
      )}
      {visibleItems?.includes('autosize') && (
        <MenuItem
          disabled={isColumnMenuBusy}
          onClick={async e => {
            try {
              await handleAutosizeColumns?.()
            } finally {
              hideMenu(e)
            }
          }}
        >
          <ListItemIcon sx={MENU_ICON_SLOT_SX}>
            {isAutosizingColumns ? (
              <CircularProgress color='inherit' size={14} />
            ) : (
              <AutoFixHighIcon fontSize='small' />
            )}
          </ListItemIcon>
          {t('configEntity.view.autosizeColumns')}
        </MenuItem>
      )}
      {visibleItems?.includes('reset') && (
        <MenuItem
          disabled={isColumnMenuBusy}
          onClick={async e => {
            try {
              await handleResetRestrictions?.()
            } finally {
              hideMenu(e)
            }
          }}
        >
          <ListItemIcon sx={MENU_ICON_SLOT_SX}>
            {isResettingRestrictions ? (
              <CircularProgress color='inherit' size={14} />
            ) : (
              <ReplayIcon fontSize='small' />
            )}
          </ListItemIcon>
          {t('configEntity.view.resetRestrictions')}
        </MenuItem>
      )}
    </GridColumnMenuContainer>
  )
}
